import { render, staticRenderFns } from "./user-agreement-for-algo-data.html?vue&type=template&id=3d9ffbad&scoped=true&external"
import script from "./user-agreement-for-algo-data.js?vue&type=script&lang=js&external"
export * from "./user-agreement-for-algo-data.js?vue&type=script&lang=js&external"
import style0 from "./user-agreement-for-algo-data.scss?vue&type=style&index=0&id=3d9ffbad&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9ffbad",
  null
  
)

export default component.exports